<link href="https://global.oktacdn.com/okta-signin-widget/5.4.0/css/okta-sign-in.min.css" type="text/css"
      rel="stylesheet"/>


 
  <div *ngIf="isAuthenticated">
    <app-header [showDropDownMenu]=!leftMenu></app-header>
  </div>
  <div [ngClass]="{'authenticated' : isAuthenticated ,'not-authenticated' : !isAuthenticated}">
    <router-outlet></router-outlet>
  </div>




